import React from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import { cn } from 'components/lib/utils';

interface SortableBlockItemProps {
  id: string;
  isHidden?: boolean;
  children: React.ReactNode;
}

export const SortableBlockItem: React.FC<SortableBlockItemProps> = ({
  id,
  isHidden = false,
  children
}) => {
  const {
    attributes,
    listeners,
    setNodeRef,
    transform,
    transition,
    isDragging
  } = useSortable({ id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition
  };

  // Clone children and pass drag handle props
  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, {
        dragHandleListeners: listeners,
        dragHandleAttributes: attributes
      } as any);
    }
    return child;
  });

  return (
    <div
      ref={setNodeRef}
      style={style}
      className={cn(
        'cursor-default select-none',
        isDragging ? 'opacity-0' : isHidden ? 'opacity-40' : 'opacity-100'
      )}
    >
      {childrenWithProps}
    </div>
  );
};
